var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("vue-img", {
        staticClass: "icon-img",
        attrs: { src: "https://jusewebapp.zmelo.com/netHospital/404.png" }
      }),
      _c("div", { staticClass: "remind" }, [
        _vm._v("哦吼！！页面找不到了，尝试刷新试试。")
      ]),
      _c("div", { staticClass: "click-item", on: { click: _vm.refresh } }, [
        _vm._v("刷新页面")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c693fef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c693fef","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/netFailure/netFailure.vue
// module id = 676
// module chunks = 25